import { styled } from '@material-ui/styles';
import { Typography } from '@material-ui/core';

export default styled(Typography)(props => ({
  fontWeight: 900,
  color: 'rgba(162, 162, 162, 1.0)'
}));
